import { saveAs } from 'file-saver';

import {
  disableMember,
  enableMember,
  getImportingRecord,
  getImportingStatus,
  getMemberInfo,
  getMemberList,
  getMemberOrders,
  importMembers,
  inviteMember,
  reverifyMember,
  sortMembersBySelected,
  updateMember,
} from '@/api/member';
import { MEMBER_STATUS } from '@/utils/constants';
import {
  DISABLE_MEMBER,
  DOWNLOAD_IMPORTING_RESULT,
  ENABLE_MEMBER,
  GET_ACTIVE_MEMBERS,
  GET_IMPORTING_RECORD,
  GET_MEMBER_INFO,
  GET_MEMBER_LIST,
  GET_MEMBER_ORDERS,
  IMPORT_MEMBERS,
  INVITE_MEMBER,
  IS_GETTING_ACTIVE_MEMBERS,
  IS_GETTING_MEMBER_LIST,
  REVERIFY_MEMBER,
  SET_MEMBERS,
  SORT_WITH_SELECTED_MEMBER,
  UPDATE_MEMBER,
} from './constants';

export default {
  async [GET_MEMBER_LIST]({ commit }, payload) {
    commit(IS_GETTING_MEMBER_LIST, true);
    try {
      const res = await getMemberList(payload);
      commit(SET_MEMBERS, res);
      return Promise.resolve(res);
    } catch (error) {
      commit(SET_MEMBERS, {});
      return Promise.reject(error);
    } finally {
      commit(IS_GETTING_MEMBER_LIST, false);
    }
  },
  async [GET_ACTIVE_MEMBERS]({ commit }, payload) {
    commit(IS_GETTING_ACTIVE_MEMBERS, true);
    try {
      const res = await getMemberList({
        per_page: 500,
        status: MEMBER_STATUS.ENABLED,
        ...payload,
      });
      commit(SET_MEMBERS, res);
      return Promise.resolve();
    } catch (error) {
      commit(SET_MEMBERS, {});
      return Promise.reject(error);
    } finally {
      commit(IS_GETTING_ACTIVE_MEMBERS, false);
    }
  },
  async [SORT_WITH_SELECTED_MEMBER]({ commit }, payload) {
    commit(IS_GETTING_ACTIVE_MEMBERS, true);
    try {
      const res = await sortMembersBySelected({
        status: MEMBER_STATUS.ENABLED,
        ...payload,
      });
      commit(SET_MEMBERS, res);
      return Promise.resolve();
    } catch (error) {
      commit(SET_MEMBERS, {});
      return Promise.reject(error);
    } finally {
      commit(IS_GETTING_ACTIVE_MEMBERS, false);
    }
  },
  async [GET_MEMBER_INFO](ctx, id) {
    const { member } = await getMemberInfo(id);
    return member;
  },
  async [UPDATE_MEMBER](ctx, { id, data }) {
    const res = await updateMember(id, data);
    return res;
  },
  async [GET_MEMBER_ORDERS](ctx, id) {
    const res = await getMemberOrders(id);
    return res;
  },
  async [INVITE_MEMBER](ctx, data) {
    await inviteMember(data);
  },
  async [ENABLE_MEMBER](ctx, id) {
    await enableMember(id);
  },
  async [DISABLE_MEMBER](ctx, id) {
    await disableMember(id);
  },
  [REVERIFY_MEMBER](ctx, data) {
    return reverifyMember(data);
  },
  [IMPORT_MEMBERS](ctx, file) {
    return importMembers(file);
  },
  async [DOWNLOAD_IMPORTING_RESULT](ctx, { uuid, filename = 'result.csv' }) {
    const res = await getImportingStatus(uuid);
    const blob = new Blob([res], { type: 'text/csv' });

    saveAs(blob, filename);
  },
  [GET_IMPORTING_RECORD]() {
    return getImportingRecord();
  },
};
